import { gql } from "@apollo/client";

export const GET_SCHOOL_FEE = gql`
  query GetSchoolFeesAccouting($keyword: String!, $type: String) {
    getSchoolFeesAccouting(keyword: $keyword, type: $type) {
      _id
      gradeName
      type
      programme
      classGroup
      prices {
        _id
        feeID
        duration
        price
        afterDicount
        discountPercentage
        discountPrice
      }
    }
  }
`;

export const ADD_FEE_ACCOUNTING = gql`
  mutation AddFeeAccouting($input: FeeAccoutInput!) {
    addFeeAccouting(input: $input) {
      status
      message
    }
  }
`;

export const DELETE_FEE_ACCOUNTING = gql`
  mutation DeleteFeeAccouting($id: ID!) {
    deleteFeeAccouting(_id: $id) {
      status
      message
    }
  }
`;

export const UPDATE_FEE_ACCOUNTING = gql`
  mutation UpdateFeeAccouting($id: ID!, $input: FeeAccoutInput!) {
    updateFeeAccouting(_id: $id, input: $input) {
      status
      message
    }
  }
`;
